export const GET_DATA_ENPS_WATCHER = "app/ReportsV2/WidgetChartEnps/GET_DATA_ENPS_WATCHER"
export const GET_DATA_ENPS_SUCCESS = "app/ReportsV2/WidgetChartEnps/GET_DATA_ENPS_SUCCESS"
export const GET_DATA_ENPS_FAILED = "app/ReportsV2/WidgetChartEnps/GET_DATA_ENPS_FAILED"
